import React from 'react'
import {
  useCurrentRefinements,
  UseCurrentRefinementsProps
} from 'react-instantsearch-core'

export const ActiveFilters = (props: UseCurrentRefinementsProps) => {
  const { items } = useCurrentRefinements(props)
  const count = items.reduce(
    (acc, item) => acc + item.refinements.length, 0,
  );

  return (
    items.length > 0 ? <span className="activeFilters">{count}</span> : null
  )
}
